function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M38 52h364c16 0 29 13 29 28 0 16-13 29-29 29H38C22 109 9 96 9 80c0-15 13-28 29-28zm0 117h185c15 0 28 13 28 28 0 16-13 29-28 29H38c-16 0-29-13-29-29 0-15 13-28 29-28zm0 117h125c15 0 28 13 28 28 0 16-13 29-28 29H38c-16 0-29-13-29-29 0-15 13-28 29-28zm0 114h170c16 0 29 12 29 28s-13 28-29 28H38c-16 0-29-12-29-28s13-28 29-28zm463-81c0 66-54 119-120 119s-119-53-119-119 53-120 119-120 120 54 120 120zm-103-14v-29c0-9-7-17-17-17-9 0-17 8-17 17v29h-33c-6 0-12 8-12 17s5 17 12 17h33v29c0 9 8 16 17 16s17-7 17-17v-28h33c7 0 13-8 13-17s-6-17-13-17z"
})));